import React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Logo } from '../../../components/blocks';

const Root = styled.header`
  z-index: 20;
  top: 0;
  width: 100%;
`;

const Wrap = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-areas: 'logo menu';
  align-items: center;
  justify-content: space-between;
  column-gap: ${({ theme }) => theme.spaces.l};
  width: 100%;
  padding: ${({ theme }) => `${theme.spaces.l} ${theme.spaces.l}`};
  background: ${({ theme }) => rgba(theme.backgroundColors.white, 0.8)};
  backdrop-filter: blur(4px);

  ${({ theme }) =>
    theme.screen.sp({
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      gridTemplateAreas: `"logo ham" "menu menu"`,
      gap: theme.spaces.s,
    })}
`;

const LogoWrap = styled(Link)`
  display: flex;
  margin: 0;
  padding: 0;
  grid-area: logo;
`;

export const HeaderSimple: React.FC = () => {
  return (
    <Root>
      <Wrap>
        <LogoWrap to="/">
          <Logo color="default" width="130" />
        </LogoWrap>
      </Wrap>
    </Root>
  );
};
